/** Route the Portal mounts this dashboard on. Kept in one place because the
 *  internal nav, deep links and redirects all need to agree on it. */
export const DAI_BASE_PATH = '/dashboard/xops-intelligence/data-assets-intelligence';

/** Static asset folder for the images copied from the original Flask app. */
export const DAI_IMG_BASE = '/dai/img';

// ─── Filter options for CustomSelectDropdown ────────────────────────────────

export interface FilterOption {
	label: string;
	value: string;
}

export const STATUS_OPTIONS: FilterOption[] = [
	{ label: 'All Statuses', value: '' },
	{ label: 'Completed (All)', value: 'completed' },
	{ label: 'On Time', value: 'success' },
	{ label: 'Delayed Start', value: 'delayed' },
	{ label: 'Missed SLA', value: 'missed_sla' },
	{ label: 'In Progress', value: 'inprog' },
	{ label: 'Missed (Not Started)', value: 'missed' },
	{ label: 'Failed', value: 'failed' },
	{ label: 'Scheduled', value: 'scheduled' }
];

export const CRITICAL_OPTIONS: FilterOption[] = [
	{ label: 'All Priority', value: '' },
	{ label: 'Critical Only', value: 'true' },
	{ label: 'Non-Critical', value: 'false' }
];

export const TRIGGER_OPTIONS: FilterOption[] = [
	{ label: 'All Triggers', value: '' },
	{ label: 'ctrl', value: 'ctrl' },
	{ label: 'event', value: 'event' }
];

export const marketOptions = (markets: string[]): FilterOption[] => [
	{ label: 'All Markets', value: '' },
	...markets.map((m) => ({ label: m, value: m }))
];
